import React from 'react'
import { Link } from 'gatsby';
import { useSiteHeaderMenu } from './../../../hook/use-site-header-menu'
import { slide as MenuMobile } from 'react-burger-menu';
import './Navigation.css'

const Navigation = ({ location }) => {
  const { menu } = useSiteHeaderMenu();
  const linkClass = 'uppercase inline-block py-2 px-4 text-white no-underline'
  const linkClassCurrent = 'uppercase inline-block text-gray-600 no-underline hover:text-gray-200 hover:text-underline py-2 px-4'
  return (
    <>
      <div className="lg:hidden">
        <MenuMobile right size={35} isOpen={false}>
          {menu && menu.map((item, i) => {
            const reg = new RegExp(item.link.replace("/", "\/"), "is")
            const classes = reg.test(location.pathname) ? linkClass : linkClassCurrent
            return (
              <Link key={`menu_mobile_${i}`} to={item.link} className={`${classes}`}> {item.label}</Link>
            )
          })}
        </MenuMobile>
      </div >

      <ul className="hidden lg:block list-reset lg:flex justify-end flex-1 items-center">
        {menu && menu.map((item, i) => {
          const reg = new RegExp(item.link.replace("/", "\/"), "is")
          const classes = reg.test(location.pathname) ? linkClass : linkClassCurrent
          return (
            <li className="mr-3" key={`menu_${i}`}>
              <Link to={item.link} className={`${classes}`}>{item.label}</Link>
            </li>
          )
        })}
      </ul >
    </>


  )

}

export default Navigation
